import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface LenderColumnHeaderProps {
  lenderName: string;
  isExample?: boolean;
  onClick?: () => void;
}

export const LenderColumnHeader: React.FC<LenderColumnHeaderProps> = ({ lenderName, isExample, onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 0.5,
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick ? { color: 'primary.main' } : undefined,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="subtitle2" fontWeight={600} noWrap>
          {lenderName}
        </Typography>
        {onClick && <ArrowForwardIcon sx={{ fontSize: 16, ml: 0.5, color: 'text.secondary' }} />}
      </Box>
      {isExample && (
        <Chip
          label="Example Only"
          size="small"
          variant="outlined"
          color="warning"
          sx={{ height: 18, fontSize: '0.65rem', fontWeight: 600 }}
        />
      )}
    </Box>
  );
};
